import axios from "axios";

// default
axios.defaults.baseURL = process.env.REACT_APP_API_URL;
axios.defaults.headers.common["Accept"] = "application/json";
axios.defaults.headers.common["Content-Type"] = "application/json";
axios.defaults.withCredentials = true;

// Função para adicionar atraso
const delay = (ms) => new Promise((resolve) => setTimeout(resolve, ms));

// Interceptor para adicionar atraso entre requisições
axios.interceptors.request.use(async (config) => {
  await delay(100); // Adiciona um atraso de 500ms entre as requisições
  return config;
});

const getLoggedinUser = async () => {
  const user = localStorage.getItem("authUser");
  if (!user) {
    return null;
  } else {
    return JSON.parse(user);
  }
};

const contemErrorCode = (str) => {
  return (
    str.includes(" 401") ||
    str === "Request failed with status code 401" ||
    str.includes("Unauthenticated")
  );
};

class APIClient {
  /**
   * Fetches data from given url
   */
  get = async (url, params) => {
    const authUser = await getLoggedinUser();
    const headers = {
      Authorization: `Bearer ${authUser?.token}`,
    };

    try {
      const response = await axios.get(url, { params, headers });
      const { mensagem, dados } = response.data;
      return {
        mensagem,
        sucesso: true,
        responseCode: response.status,
        dados,
      };
    } catch (error) {
      const mensagemErro =
        error.response?.data?.mensagem ||
        error.response?.data?.message ||
        error.response?.mensagem ||
        error.response?.message ||
        error.message ||
        error.mensagem ||
        "Ocorreu um erro desconhecido.";
      return {
        mensagem: contemErrorCode(mensagemErro)
          ? ""
          : mensagemErro,
        sucesso: false,
        responseCode: contemErrorCode(mensagemErro)
          ? 401
          : error.response?.status
          ? error.response.status
          : 403,
        dados: null,
      };
    }
  };

  /**
   * post given data to url
   */
  post = async (url, data) => {
    const formEncodedData = new URLSearchParams();
    for (const key in data) {
      formEncodedData.append(key, data[key]);
    }

    const authUser = await getLoggedinUser();
    const headers = {
      Authorization: `Bearer ${authUser?.token}`,
    };

    try {
      const response = await axios.post(url, data, { headers });
      const { mensagem, dados } = response.data;
      return {
        mensagem,
        sucesso: true,
        responseCode: response.status,
        dados,
      };
    } catch (error) {
      let mensagemErro =
        error.response?.data?.mensagem ||
        error.response?.data?.message ||
        error.response?.mensagem ||
        error.response?.message ||
        error.message ||
        error.mensagem ||
        "Ocorreu um erro desconhecido.";

      if (
        error.response?.data?.erro?.includes("users_email_unique") ||
        error.response?.erro?.includes("users_email_unique")
      ) {
        mensagemErro = "Email ja cadastrado";
      }
      console.error(error.response);
      return {
        mensagem: contemErrorCode(mensagemErro)
          ? ""
          : mensagemErro,
        sucesso: false,
        responseCode: contemErrorCode(mensagemErro)
          ? 401
          : error.response?.status
          ? error.response.status
          : 403,
        dados: error.response?.data?.dados,
      };
    }
  };

  /**
   * post for download endpoints
   */
  postDownload = async (url, data) => {
    const authUser = await getLoggedinUser();
    const headers = {
      Authorization: `Bearer ${authUser?.token}`,
    };

    try {
      const response = await axios.post(url, data, {
        headers,
        responseType: "blob",
      });

      return {
        sucesso: true,
        responseCode: response.status,
        dados: response.data,
        headers: response.headers,
      };
    } catch (error) {
      let mensagemErro =
        error.response?.data?.mensagem ||
        error.response?.mensagem ||
        error.response?.data?.message ||
        error.response?.message ||
        error.message ||
        error.mensagem ||
        "Ocorreu um erro desconhecido.";
      console.error(error.response);
      return {
        sucesso: false,
        responseCode: error.response?.status || 500,
        mensagem: mensagemErro,
      };
    }
  };

  /**
   * post given data to url
   */
  postLogin = async (data) => {
    try {
      const response = await axios.post(
        `${process.env.REACT_APP_API_URL}/guest/login`,
        data
      );
      const { mensagem, dados } = response.data;
      return {
        mensagem,
        sucesso: true,
        responseCode: response.status,
        dados,
      };
    } catch (error) {
      const mensagemErro =
        error.response?.data?.mensagem ||
        error.response?.data?.message ||
        error.response?.mensagem ||
        error.response?.message ||
        error.message ||
        error.mensagem ||
        "Ocorreu um erro desconhecido.";
      console.error(mensagemErro);
      return {
        mensagem: contemErrorCode(mensagemErro)
          ? ""
          : mensagemErro,
        sucesso: false,
        responseCode: contemErrorCode(mensagemErro)
          ? 401
          : error.response?.status
          ? error.response.status
          : 403,
        dados: data,
      };
    }
  };

  /**
   * Updates data
   */
  update = async (url, data) => {
    const authUser = await getLoggedinUser();
    const headers = {
      Authorization: `Bearer ${authUser?.token}`,
    };

    try {
      const response = await axios.patch(url, data, { headers });
      const { mensagem, dados } = response.data;
      return {
        mensagem,
        sucesso: true,
        responseCode: response.status,
        dados,
      };
    } catch (error) {
      const mensagemErro =
        error.response?.data?.mensagem ||
        error.response?.data?.message ||
        error.response?.mensagem ||
        error.response?.message ||
        error.message ||
        error.mensagem ||
        "Ocorreu um erro desconhecido.";
      return {
        mensagem: contemErrorCode(mensagemErro)
          ? ""
          : mensagemErro,
        sucesso: false,
        responseCode: contemErrorCode(mensagemErro)
          ? 401
          : error.response?.status
          ? error.response.status
          : 403,
        dados: null,
      };
    }
  };

  put = async (url, data) => {
    const authUser = await getLoggedinUser();
    const headers = {
      Authorization: `Bearer ${authUser?.token}`,
    };

    try {
      const response = await axios.put(url, data, { headers });
      const { mensagem, dados } = response.data;
      return {
        mensagem,
        sucesso: true,
        responseCode: response.status,
        dados,
      };
    } catch (error) {
      const mensagemErro =
        error.response?.data?.mensagem ||
        error.response?.data?.message ||
        error.response?.mensagem ||
        error.response?.message ||
        error.message ||
        error.mensagem ||
        "Ocorreu um erro desconhecido.";
      return {
        mensagem: contemErrorCode(mensagemErro)
          ? ""
          : mensagemErro,
        sucesso: false,
        responseCode: contemErrorCode(mensagemErro)
          ? 401
          : error.response?.status
          ? error.response.status
          : 403,
        dados: null,
      };
    }
  };

  /**
   * Delete
   */
  delete = async (url, params, config = {}) => {
    const authUser = await getLoggedinUser();
    const headers = {
      Authorization: `Bearer ${authUser?.token}`,
    };

    try {
      const response = await axios.delete(url, { ...config, headers, params });
      const { mensagem, dados } = response.data;
      return {
        mensagem,
        sucesso: true,
        responseCode: response.status,
        dados,
      };
    } catch (error) {
      const mensagemErro =
        error.response?.data?.mensagem ||
        error.response?.data?.message ||
        error.response?.mensagem ||
        error.response?.message ||
        error.message ||
        error.mensagem ||
        "Ocorreu um erro desconhecido.";
      return {
        mensagem: contemErrorCode(mensagemErro)
          ? ""
          : mensagemErro,
        sucesso: false,
        responseCode: contemErrorCode(mensagemErro)
          ? 401
          : error.response?.status
          ? error.response.status
          : 403,
        dados: null,
      };
    }
  };
}

export { APIClient, getLoggedinUser };
